import type {ForEachAction} from 'src/action-creators/for-each';
import {
  RECEIVE_FOR_EACH,
  RESET,
  UPDATE_FOR_EACH,
} from 'src/action-creators/for-each';
import {getDefaultForEachState} from 'src/utils/for-each';


export type ForEachState = {
  batchSize: string | null | undefined;
  previousNodeId: string | null | undefined;
  idKey: string | null | undefined;
  frequency: string;
  interval: string;
  batching: boolean;
};

const initialState = getDefaultForEachState();

export default (
  state: ForEachState | null | undefined = initialState,
  action: ForEachAction,
): ForEachState => {
  switch (action.type) {
    //note(vish): both receive and update do the same thing. Keeping separate coz things might change down the line.
    case RECEIVE_FOR_EACH:
    case UPDATE_FOR_EACH:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  // @ts-expect-error - TS2322 - Type 'ForEachState | null' is not assignable to type 'ForEachState'.
  return state;
};
